import { DataSource, GridItem } from '@juristat/common/types'
import { createContext } from 'react'

type UpdateItems = (items: GridItem[], options: { autoSave: boolean }) => void

export const DashboardDataSourceContext = createContext<DataSource | undefined>(undefined)
export const DashboardItemsContext = createContext<GridItem[] | undefined>(undefined)
export const DashboardUpdateItemsContext = createContext<UpdateItems | undefined>(undefined)
export const IsChartsLibraryContext = createContext<true | undefined>(undefined)
